import isExperienceEditor from '@utils/is-experience-editor';

(function() {
    if ($('.hero__slider__item').length <= 1) {
        return;
    }

    $('.hero__slider-controls.-hidden').removeClass('-hidden');

    var heroSlider = function() {
        var ui = {};

        function cacheUI() {
            ui.$body = $('body');
            ui.$hero = $('.-slider-on .hero__slider');
        }

        function initHeroSlider(e) {
            ui.$hero.each(function(index, element) {
                $(this).addClass('js-hero-slider' + index);
                var item_length = $('.js-hero-slider' + index + ' > div')
                    .length;
                if (item_length > 1 && !isExperienceEditor) {
                    $('.js-hero-slider' + index).slick({
                        autoplay: true,
                        autoplaySpeed: 5000,
                        infinite: false,
                        arrows: true,
                        dots: false,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        prevArrow: $('.hero__slider-controls__arrow-prev'),
                        nextArrow: $('.hero__slider-controls__arrow-next'),
                        adaptiveHeight: false,
                        fade: true,
                        speed: 1000,
                        cssEase: 'linear',
                        rows: 0, // Fix vor v1.8.0-1
                        responsive: [
                            {
                                breakpoint: 1200,
                                settings: {
                                    slidesToShow: 1,
                                    slidesToScroll: 1,
                                },
                            },
                            {
                                breakpoint: 767,
                                settings: {
                                    slidesToShow: 1,
                                    slidesToScroll: 1,
                                    arrows: false,
                                    dots: true,
                                },
                            },
                        ],
                    });
                }
            });

            $('.hero__slider-controls__pause').click(function(e) {
                $('.hero__slider')
                    .slick('slickSetOption', 'autoplay', false)
                    .slick('slickPause');
                $('.hero__slider-controls').toggleClass('-paused');
            });

            $('.hero__slider-controls__play').click(function(e) {
                $('.hero__slider')
                    .slick('slickSetOption', 'autoplay', true)
                    .slick('slickPlay');
                $('.hero__slider-controls').toggleClass('-paused');
            });

            let heroItems = $('.hero__slider__item').length;
            console.dir(heroItems);

            ui.$hero.addClass('initialize');
        }

        function init() {
            cacheUI();
            initHeroSlider();
        }

        return {
            init: init,
        };
    };

    var heroSlider = heroSlider();
    heroSlider.init();
})(window);
